import { formatTimestamp, roundDownWtn } from '../../../utils'
import { globalLegendConfiguration } from '../ChartsGlobalConfiguration'

export const getHistoryLineChartOptions = (options: {
  yMin: number
  yMax: number
  yTicksLimit: number
  yStepSize: number
  xTicksRotation: number
}) => {
  const { yMin, yMax, yTicksLimit, yStepSize, xTicksRotation } = options

  return {
    scaleShowVerticalLines: true,
    height: 400,
    tooltips: {
      titleSpacing: 6,
      xPadding: 20,
      yPadding: 20,
      textAlign: 'center',
      backgroundColor: '#16234C',
      titleFontColor: '#ffffff',
      titleFontSize: 12,
      titleFontFamily: 'Poppins',
      titleFontStyle: 'normal',
      titleAlign: 'center',
      bodyFontColor: '#ffffff',
      bodyFontSize: 12,
      bodyFontFamily: 'Poppins',
      bodyFontStyle: 'normal',
      mode: 'index',
      intersect: false,
      callbacks: {
        title: function (tooltipItems) {
          return formatTimestamp(new Date(tooltipItems[0].xLabel))
        },
        label: function (tooltipItem) {
          return roundDownWtn(tooltipItem.yLabel)
        },
        labelColor: function (tooltipItem, chart) {
          if (typeof tooltipItem?.datasetIndex !== 'number') return {}

          const { backgroundColor } =
            chart?.config?.data?.datasets?.[tooltipItem.datasetIndex] ?? {}

          if (!backgroundColor) return {}

          return {
            backgroundColor,
          }
        },
      },
    },
    hover: {
      mode: 'nearest',
      intersect: true,
    },
    legend: globalLegendConfiguration,
    borderWidth: 20,
    maintainAspectRatio: false,
    bezierCurve: true,
    bezierCurveTension: 0.5,
    pointDot: true,
    pointDotRadius: 5,
    pointDotStrokeWidth: 10,
    pointHitDetectionRadius: 20,
    datasetStroke: true,
    datasetStrokeWidth: 2,
    spanGaps: true,
    scales: {
      xAxes: [
        {
          type: 'time',
          bounds: 'data',
          time: {
            unit: 'month',
            displayFormats: {
              month: `MMM 'YY`,
            },
          },
          gridLines: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            autoSkip: true,
            maxRotation: xTicksRotation,
            minRotation: xTicksRotation,
            maxTicksLimit: 12,
            fontFamily: 'Poppins',
            fontSize: 10,
            fontStyle: 'normal',
            fontColor: '#737680',
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            maxTicksLimit: yTicksLimit,
            beginAtZero: false,
            display: true,
            min: yMin,
            max: yMax,
            stepSize: yStepSize,
            reverse: true,
            padding: 20,
            fontFamily: 'Poppins',
            fontSize: 10,
            fontStyle: 'normal',
            fontColor: '#737680',
          },
          gridLines: {
            drawBorder: false,
          },
        },
      ],
    },
  }
}
